import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
import { ContentEntityTypeSchema, SurfaceTypeSchema } from "./surface-grammar.js";
export const CertificationLifecycleStatusSchema = z.enum([
    "candidate",
    "certified",
    "deprecated",
    "rejected",
]);
export const StrategySchema = z
    .object({
    strategyId: z.string().min(1),
    strategyVersion: z.string().min(1),
    displayName: z.string().min(1),
    lifecycleStatus: CertificationLifecycleStatusSchema.default("candidate"),
    compatibleSurfaceTypes: z.array(SurfaceTypeSchema).default(["marketingSite"]),
    compatibleEntityTypes: z.array(ContentEntityTypeSchema).default(["localServiceBusiness"]),
    compatibleLensIds: z.array(z.string().min(1)).default([]),
    requiredRoles: z.array(ComponentRoleSchema).default([]),
    optionalRoles: z.array(ComponentRoleSchema).default([]),
    sectionPriority: z.array(ComponentRoleSchema).default([]),
    ctaBehavior: z.string().min(1),
    proofBehavior: z.string().min(1),
    fallbackBehavior: z.string().min(1),
})
    .strict();
export const StrategyRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("strategy-registry.v1.0"),
    registryVersion: z.string().min(1),
    strategies: z.array(StrategySchema),
})
    .strict();
//# sourceMappingURL=strategy.js.map